import { routes } from "@/router/all_routes";

/** Mot de passe commun des comptes démo (voir core/demo/README.md). */
export const DEMO_CAPTURE_PASSWORD = "Admin@123456";

export interface DemoCapturePage {
  id: string;
  label: string;
  path: string;
  canvaSlots?: string[];
  waitMs?: number;
  captureSelector?: string;
}

export interface DemoCaptureProfile {
  id: string;
  label: string;
  email: string;
  password: string;
  pages: DemoCapturePage[];
}

/**
 * Parcours marketing Hospitol — aligné présentation RDC et parcours démo.
 * Fichiers générés : `assets/canva/captures/{profil}__{page}.png`
 */
export const DEMO_CAPTURE_PROFILES: DemoCaptureProfile[] = [
  {
    id: "direction",
    label: "Direction médicale",
    email: "manager@hospital.demo",
    password: DEMO_CAPTURE_PASSWORD,
    pages: [
      {
        id: "tableau-de-bord",
        label: "Tableau de bord",
        path: routes.tenantDashboard,
        waitMs: 3200,
      },
      {
        id: "admissions",
        label: "Admissions",
        path: routes.admissions,
        waitMs: 3200,
      },
      {
        id: "patients",
        label: "Liste patients",
        path: routes.patients,
        waitMs: 3200,
      },
      {
        id: "assurance-accueil",
        label: "Assurance — accueil",
        path: routes.insuranceHome,
        waitMs: 3200,
      },
      {
        id: "assurance-dossiers",
        label: "Assurance — dossiers",
        path: routes.insuranceCases,
        waitMs: 3200,
      },
      {
        id: "caisse",
        label: "Caisse",
        path: routes.billingCashier,
        waitMs: 3200,
      },
      {
        id: "comptabilite",
        label: "Comptabilité",
        path: routes.billingAccounting,
        waitMs: 3200,
      },
    ],
  },
  {
    id: "medecin",
    label: "Médecin",
    email: "doctor@hospital.demo",
    password: DEMO_CAPTURE_PASSWORD,
    pages: [
      {
        id: "consultations",
        label: "Consultations",
        path: routes.consultations,
        waitMs: 3200,
      },
      {
        id: "prescriptions",
        label: "Prescriptions",
        path: routes.prescriptions,
        waitMs: 3200,
      },
      {
        id: "laboratoire",
        label: "Laboratoire",
        path: routes.laboratory,
        waitMs: 3000,
      },
      {
        id: "imagerie",
        label: "Imagerie",
        path: routes.imaging,
        waitMs: 3000,
      },
    ],
  },
  {
    id: "pharmacien",
    label: "Pharmacien",
    email: "pharmacy@hospital.demo",
    password: DEMO_CAPTURE_PASSWORD,
    pages: [
      {
        id: "ordonnances",
        label: "Ordonnances à traiter",
        path: routes.pharmacyOrders,
        waitMs: 3600,
      },
      {
        id: "dispensation",
        label: "Dispensation / facture",
        path: routes.pharmacyInvoice,
        waitMs: 3600,
      },
      {
        id: "stock-articles",
        label: "Stock pharmacie",
        path: routes.pharmacyStockArticles,
        waitMs: 3200,
      },
      {
        id: "historique-factures",
        label: "Historique factures",
        path: routes.pharmacyInvoiceHistory,
        waitMs: 3200,
      },
    ],
  },
  {
    id: "accueil",
    label: "Accueil",
    email: "staff@hospital.demo",
    password: DEMO_CAPTURE_PASSWORD,
    pages: [
      {
        id: "urgences",
        label: "Urgences",
        path: routes.emergency,
        waitMs: 3000,
      },
      {
        id: "rendez-vous",
        label: "Rendez-vous",
        path: routes.appointments,
        waitMs: 3000,
      },
    ],
  },
];

export function buildCaptureFilename(profileId: string, pageId: string): string {
  return `${profileId}__${pageId}.png`;
}

export function listAllCaptureFilenames(): string[] {
  return DEMO_CAPTURE_PROFILES.flatMap((profile) =>
    profile.pages.map((page) => buildCaptureFilename(profile.id, page.id)),
  );
}

/** Pages uniques (par id) agrégées depuis tous les profils. */
export function listAllUniquePages(): DemoCapturePage[] {
  const seen = new Map<string, DemoCapturePage>();
  for (const profile of DEMO_CAPTURE_PROFILES) {
    for (const page of profile.pages) {
      if (!seen.has(page.id)) seen.set(page.id, page);
    }
  }
  return [...seen.values()];
}
